/** @format */

import * as React from 'react';

export const IconArrowBottom = () => {
    return (
        <svg
            width="15"
            height="9"
            viewBox="0 0 15 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.11348 8.28036L14.7199 0.230359C14.7373 0.209324 14.7481 0.184044 14.7511 0.157424C14.7541 0.130803 14.7491 0.103922 14.7368 0.0798656C14.7244 0.0558095 14.7052 0.0355552 14.6813 0.0214282C14.6574 0.00730121 14.6298 -0.000125384 14.6017 1.59523e-06L13.1513 1.53489e-06C13.0594 1.53106e-06 12.9712 0.0410731 12.9149 0.10893L7.64065 6.5375L2.36639 0.10893C2.3101 0.0392869 2.22191 1.08021e-06 2.12998 1.07639e-06L0.679601 1.01605e-06C0.553889 1.01082e-06 0.484467 0.137501 0.561395 0.230358L7.16783 8.28036C7.2239 8.34878 7.29564 8.40413 7.37757 8.4422C7.4595 8.48027 7.54948 8.50005 7.64065 8.50005C7.73183 8.50005 7.8218 8.48027 7.90373 8.4422C7.98567 8.40413 8.0574 8.34878 8.11348 8.28036Z"
                fill="white"
            />
        </svg>
    );
};
